import styled from 'styled-components';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	width: 370px;
	gap: 60px;
	padding: 24px;
`;

export const H3 = styled.h3`
	margin-bottom: 8px;
	font-size: 24px;
	color: ${({ theme }) => theme.colors.neutral.black};
`;

export const H4 = styled.h4`
	font-size: 16px;
	line-height: 20px;
	color: ${({ theme }) => theme.colors.neutral.black};
`;

export const P = styled.p`
	font-size: 16px;
	line-height: 28px;
	color: ${({ theme }) => theme.colors.body.light};
`;

export const ContactUl = styled.ul`
	display: flex;
	flex-direction: column;
	gap: 8px;
	list-style: none;
`;

export const ContactInfo = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	font-size: 16px;
	color: ${({ theme }) => theme.colors.primary.medium};

	p {
		color: ${({ theme }) => theme.colors.neutral.black};
	}

	a {
		color: ${({ theme }) => theme.colors.neutral.black};
		text-decoration: none;

		&:hover {
			color: ${({ theme }) => theme.colors.primary.medium};
			transition: color 0.3s;
		}
	}
`;

export const SocialUl = styled.ul`
	display: flex;
	gap: 16px;
	list-style: none;
`;
